




























export default {
  name: 'FAQs',
  props: {
    faqs: {
      type: Object,
      default: undefined
    }
  },
  methods: {
    titleToSlug(linkName: string): string {
      const editLink = linkName.toLowerCase().replace(/[?"']/g, '');
      return editLink.split(' ').join('-');
    }
  }
};
